/* Built in imports */
import React from 'react';

/* Third party imports */
import Typography from '@mui/material/Typography';
import { Field } from 'redux-form';

/* Internal imports */
import { YesChoix } from '../../../../form/Choix';
import { TransHtmlText } from '../../../../yes/utils/TransHtmlText';
import { requiredValidator } from '../../../../../common/Validators';
import { ANCIENNETE_MINIMUM } from '../../../../../utils/constantes/US/DISPOSITIFABONDEMENT';

const AncienneteMinimum = ({ ancienneteMinimum }) => (
  <>
    <div className="anciennete-mini-selector">
      <Typography variant="div" className="label-checkbox-v2 anciennete-mini-selector divLabel">
        <TransHtmlText i18nKey="dispositif.info.abondement.anciennete.minimum" />
      </Typography>
    </div>
    <div className="tunnelRadios">
      {ANCIENNETE_MINIMUM.map((anciennete) => (
        <div className="tunnelRadio" key={anciennete.value}>
          <Field
            name="ancienneteMinimum"
            component={YesChoix}
            type="radio"
            value={anciennete.value}
            label={anciennete.label}
            id={anciennete.value}
            validate={requiredValidator}
          />
        </div>
      ))}
    </div>
    {!ancienneteMinimum && <p className="errorMsgTauxDegressif">Vous devez fixer la condition d’ancienneté.</p>}
  </>
);

export default AncienneteMinimum;
